"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

var _GatewayService = _interopRequireDefault(require("../GatewayService.js"));

var _log = _interopRequireDefault(require("../log.js"));

var _errors = require("../errors.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// Note user-storage-service/state proxies client-state-service
var storage = new _GatewayService["default"]('client-state-service');

var saveStateToStorage = function saveStateToStorage(userKey, appKey, data) {
  return storage.post("state/".concat(userKey, "/").concat(appKey), data);
};

var fetchStateFromStorage = function fetchStateFromStorage(userKey, appKey) {
  return storage.get("state/".concat(userKey, "/").concat(appKey));
};

var deleteStateFromStorage = function deleteStateFromStorage(userKey, appKey) {
  return storage["delete"]("state/".concat(userKey, "/").concat(appKey));
};

var fetchClientState = function fetchClientState(userKey) {
  return storage.get("state/".concat(userKey, "/clientState"));
};

var saveClientState = function saveClientState(userKey, clientState) {
  return storage.post("state/".concat(userKey, "/clientState"), clientState, {
    headers: {
      'Content-Type': 'text/plain'
    }
  });
};

var deleteClientState = function deleteClientState(userKey) {
  return storage["delete"]("state/".concat(userKey, "/clientState"));
};

var saveLastStartedClass = function saveLastStartedClass(userKey, classKey, classState) {
  if (_lodash["default"].isEmpty(userKey)) {
    _log["default"].error('Last started class not saved because userKey was not specified');

    return Promise.reject((0, _errors.missingParam)('userKey'));
  }

  if (_lodash["default"].isEmpty(classKey)) {
    _log["default"].error('Last started class not saved because classKey was not specified');

    return Promise.reject((0, _errors.missingParam)('classKey'));
  }

  return storage.post("state/".concat(userKey, "/lastLessonLocation:").concat(classKey), classState, {
    headers: {
      'Content-Type': 'application/json'
    }
  });
};

var saveLastLessonViewedLocation = function saveLastLessonViewedLocation(userKey, classState) {
  if (_lodash["default"].isEmpty(userKey)) {
    _log["default"].error('Last lesson viewed not saved because userKey was not specified');

    return Promise.reject((0, _errors.missingParam)('userKey'));
  }

  return storage.post("state/".concat(userKey, "/lastLessonView"), classState, {
    headers: {
      'Content-Type': 'application/json'
    }
  });
};

var fetchLanguageState = function fetchLanguageState(userKey) {
  return storage.get("state/".concat(userKey, "/languageState"));
};

var saveLanguageState = function saveLanguageState(userKey, languageState) {
  if (_lodash["default"].isEmpty(languageState)) {
    return Promise.reject((0, _errors.missingParam)('languageState'));
  }

  return storage.post("state/".concat(userKey, "/languageState"), languageState, {
    headers: {
      'Content-Type': 'text/plain'
    }
  });
};

var fetchAllLanguageStates = function fetchAllLanguageStates() {
  var userKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  if (_lodash["default"].isEmpty(userKeys)) {
    return Promise.reject((0, _errors.missingParam)('userKeys'));
  }

  return storage.post("state/batch-get/languageState", userKeys, {
    headers: {
      'Content-Type': 'text/plain'
    }
  });
};

var saveAllLanguageStates = function saveAllLanguageStates() {
  var userStates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  if (_lodash["default"].isEmpty(userStates)) {
    return Promise.reject((0, _errors.missingParam)('userStates'));
  }

  return storage.post("state/batch-post/languageState", userStates, {
    headers: {
      'Content-Type': 'text/plain'
    }
  });
};

var getControllerState = function getControllerState(_ref, controller) {
  var userKey = _ref.userKey;
  return storage.get("state/".concat(userKey, "/").concat(controller, "State"));
};

var saveControllerState = function saveControllerState(_ref2, controller) {
  var userKey = _ref2.userKey,
      state = _ref2.state;

  if (_lodash["default"].isEmpty(state)) {
    return Promise.reject((0, _errors.missingParam)('state'));
  }

  return storage.post("state/".concat(userKey, "/").concat(controller, "State"), state, {
    headers: {
      'Content-Type': 'text/plain'
    }
  });
};

var fetchAllControllerStates = function fetchAllControllerStates(_ref3, controller) {
  var _ref3$userKeys = _ref3.userKeys,
      userKeys = _ref3$userKeys === void 0 ? [] : _ref3$userKeys;

  if (_lodash["default"].isEmpty(userKeys)) {
    return Promise.reject((0, _errors.missingParam)('userKeys'));
  }

  return storage.post("state/batch-get/".concat(controller, "State"), userKeys, {
    headers: {
      'Content-Type': 'text/plain'
    }
  });
};

var saveAllControllerStates = function saveAllControllerStates(_ref4, controller) {
  var _ref4$userStates = _ref4.userStates,
      userStates = _ref4$userStates === void 0 ? [] : _ref4$userStates;

  if (_lodash["default"].isEmpty(userStates)) {
    return Promise.reject((0, _errors.missingParam)('userStates'));
  }

  userStates.forEach(function (state) {
    if (!state['userBusinessKey'] || !state['clientState']) {
      return Promise.reject((0, _errors.missingParam)('userStates'));
    }

    state['clientState'] = JSON.stringify(state['clientState']);
  });
  return storage.post("state/batch-post/".concat(controller, "State"), userStates, {
    headers: {
      'Content-Type': 'text/plain'
    }
  });
};

var controllerEnum = Object.freeze({
  language: 'language',
  lessonTools: 'lessonTools',
  assessmentTools: 'assessmentTools',
  teacherTools: 'teacherTools'
});

var useSpecificControllerAction = function useSpecificControllerAction(controller, data, callback) {
  if (!controller) {
    return Promise.reject((0, _errors.missingParam)('controller'));
  }

  switch (controller) {
    case controllerEnum.lessonTools:
      return callback(data, controller);

    case controllerEnum.assessmentTools:
      return callback(data, controller);

    case controllerEnum.teacherTools:
      return callback(data, controller);

    default:
      return Promise.reject((0, _errors.missingControllerName)(controller));
  }
};
/**
 * Fetch state for specific user
 * @constructor
 * @param {controller :controllerEnum} controller
 * @param {userKey: string} userKey
 *
/**
 *
 * Returns Object with userBusinessKey and clientState
 * @returns {Object<userBusinessKey,clientState>}
 * @param {LanguageState | ToolsState} state
 */


var fetchClassroomSettingState = function fetchClassroomSettingState(controller, userKey) {
  if (controllerEnum.language === controller) {
    return fetchLanguageState(userKey);
  }

  return useSpecificControllerAction(controller, {
    userKey: userKey
  }, getControllerState);
};
/**
 * @typedef {Object} LanguageState
 * @property {string} selectedLanguage selected language
 * @property {null | Object} languageOverride language override
 * @property {boolean} allowEdit  allow edit
 * @property {{
 *     selectedLanguage:string,
 *     languageOverride:null | any,
 *     allowEdit:boolean
 * }} demoStudent property for demo student
 */

/**
 * @typedef {Object} ToolsState
 * @property {boolean} scientificCalcEnabled  enabled to use scientific calculator
 * @property {boolean} graphicCalcEnabled  enabled to use graphic calculator
 * @property {boolean} scratchpadEnabled  enabled to use scratchpad
 * @property {boolean} handRaiseEnabled  enabled to use handRaise
 */

/**
 * Save state for specific user
 * @constructor
 * @param {controller: controllerEnum} controller
 * @param {userKey: string} userKey
 * @param {state: Object.<LanguageState | ToolsState >} state
 * Specific controller name with object of {userKey: string}.
 */


var saveClassroomSettingState = function saveClassroomSettingState(controller, userKey, state) {
  if (controllerEnum.language === controller) {
    return saveLanguageState(userKey, state);
  }

  return useSpecificControllerAction(controller, {
    userKey: userKey,
    state: state
  }, saveControllerState);
};
/**
 * Fetch state
 * @constructor
 *  @param {controller :controllerEnum} controller
 * @param {userKeys:Array<string>} userKeys
 * /**
 *
 * Returns Object with userBusinessKey and clientState
 * @returns {Object<userBusinessKey,clientState>}
 * @param {clientState :Object.<LanguageState | ToolsState>} clientState
 * @param {userBusinessKey: string} userBusinessKey
 */


var fetchAllClassroomSettingStates = function fetchAllClassroomSettingStates(controller, userKeys) {
  if (controllerEnum.language === controller) {
    return fetchAllLanguageStates(userKeys);
  }

  return useSpecificControllerAction(controller, {
    userKeys: userKeys
  }, fetchAllControllerStates);
};
/**
 * Save state
 * @constructor
 * @param {controller :controllerEnum} controller
 * @param {userStates: Array<
 * userBusinessKey:string,
 * clientState:Object.<LanguageState | ToolsState>>} userStates
 * Specific controller name with object of {userStates: arguments}.
 */


var saveAllClassroomSettingStates = function saveAllClassroomSettingStates(controller, userStates) {
  if (controllerEnum.language === controller) {
    return saveAllLanguageStates(userStates);
  }

  return useSpecificControllerAction(controller, {
    userStates: userStates
  }, saveAllControllerStates);
};

var fetchLastLessonLocation = function fetchLastLessonLocation(userKey, classKey) {
  return storage.get("state/".concat(userKey, "/lastLessonLocation:").concat(classKey));
};

var fetchLastLessonViewedLocation = function fetchLastLessonViewedLocation(userKey) {
  return storage.get("state/".concat(userKey, "/lastLessonView"));
};

var fetchClassworkState = function fetchClassworkState(userKey) {
  return storage.get("state/".concat(userKey, "/classworkState"));
};

var saveClassworkState = function saveClassworkState(userKey, classworkState) {
  if (_lodash["default"].isEmpty(classworkState)) {
    return Promise.reject((0, _errors.missingParam)('classworkState'));
  }

  return storage.post("state/".concat(userKey, "/classworkState"), classworkState, {
    headers: {
      'Content-Type': 'text/plain'
    }
  });
};

var fetchClassContentState = function fetchClassContentState(userKey, classId) {
  return storage.get("state/".concat(userKey, "/classContentState:").concat(classId));
};

var saveClassContentState = function saveClassContentState(userKey, classId, classContentState) {
  if (_lodash["default"].isEmpty(userKey)) {
    return Promise.reject((0, _errors.missingParam)('userKey'));
  }

  if (_lodash["default"].isEmpty(classId)) {
    return Promise.reject((0, _errors.missingParam)('classId'));
  }

  if (_lodash["default"].isEmpty(classContentState)) {
    return Promise.reject((0, _errors.missingParam)('classContentState'));
  }

  return storage.post("state/".concat(userKey, "/classContentState:").concat(classId), classContentState, {
    headers: {
      'Content-Type': 'text/plain'
    }
  });
};

var saveAllClassContentStates = function saveAllClassContentStates(classId, classContentStates) {
  if (_lodash["default"].isEmpty(classId)) {
    return Promise.reject((0, _errors.missingParam)('classId'));
  }

  if (_lodash["default"].isEmpty(classContentStates)) {
    return Promise.reject((0, _errors.missingParam)('classContentStates'));
  }

  return storage.post("state/batch-post/classContentState:".concat(classId), classContentStates, {
    headers: {
      'Content-Type': 'text/plain'
    }
  });
};

var fetchStudentState = function fetchStudentState(userKey) {
  return storage.get("state/".concat(userKey, "/studentState"));
};

var saveStudentState = function saveStudentState(userKey, studentState) {
  if (_lodash["default"].isEmpty(studentState)) {
    return Promise.reject((0, _errors.missingParam)('studentState'));
  }

  return storage.post("state/".concat(userKey, "/studentState"), studentState, {
    headers: {
      'Content-Type': 'text/plain'
    }
  });
};

var fetchCustomComments = function fetchCustomComments(userKey) {
  return storage.get("state/".concat(userKey, "/customComments"));
};

var saveCustomComments = function saveCustomComments(userKey, customComments) {
  if (_lodash["default"].isEmpty(userKey)) {
    return Promise.reject((0, _errors.missingParam)('userKey'));
  }

  if (_lodash["default"].isEmpty(customComments)) {
    return Promise.reject((0, _errors.missingParam)('customComments'));
  }

  return storage.post("state/".concat(userKey, "/customComments"), customComments, {
    headers: {
      'Content-Type': 'text/plain'
    }
  });
};

var saveGoogleDocId = function saveGoogleDocId(userKey, activityKey, documentId) {
  if (_lodash["default"].isEmpty(userKey)) {
    _log["default"].error('Google Document Id not saved because userKey was not specified');

    return Promise.reject((0, _errors.missingParam)('userKey'));
  }

  if (_lodash["default"].isEmpty(activityKey)) {
    _log["default"].error('Google Document Id not saved because activityKey was not specified');

    return Promise.reject((0, _errors.missingParam)('activityKey'));
  }

  if (_lodash["default"].isEmpty(documentId)) {
    _log["default"].error('Google Document Id not saved because documentId was not specified');

    return Promise.reject((0, _errors.missingParam)('documentId'));
  }

  return storage.post("state/".concat(userKey, "/googleDoc:").concat(activityKey), documentId, {
    headers: {
      'Content-Type': 'text/plain'
    }
  });
};

var fetchGoogleDocId = function fetchGoogleDocId(userKey, activityKey) {
  return storage.get("state/".concat(userKey, "/googleDoc:").concat(activityKey));
};

var deleteGoogleDocId = function deleteGoogleDocId(userKey, activityKey) {
  return storage["delete"]("state/".concat(userKey, "/googleDoc:").concat(activityKey));
};

var fetchUserFile = function fetchUserFile(userKey, fileKey) {
  return storage.get("state/".concat(userKey, "/").concat(fileKey));
};

var saveUserFile = function saveUserFile(userKey, fileKey, data) {
  return storage.post("state/".concat(userKey, "/").concat(fileKey), data);
};

var saveStudentAudioAccessState = function saveStudentAudioAccessState(userKey, subject, audioState) {
  return storage.post("state/".concat(userKey, "/audioAccessState:").concat(subject), {
    audioState: audioState
  }, {
    headers: {
      'Content-Type': 'text/plain'
    }
  });
};

var saveAllStudentAudioAccessStates = function saveAllStudentAudioAccessStates(subject, audioAccessStates) {
  return storage.post("state/batch-post/audioAccessState:".concat(subject), audioAccessStates, {
    headers: {
      'Content-Type': 'text/plain'
    }
  });
};

var fetchStudentAudioAccessState = function fetchStudentAudioAccessState(userKey, subject) {
  return storage.get("state/".concat(userKey, "/audioAccessState:").concat(subject));
};

var fetchAllStudentAudioAccessStates = function fetchAllStudentAudioAccessStates(userKeys, subject) {
  return storage.post("state/batch-get/audioAccessState:".concat(subject), userKeys);
};

var saveOptInStatusForUser = function saveOptInStatusForUser(userKey, isOptedIn) {
  if (_lodash["default"].isEmpty(userKey)) {
    _log["default"].error('Opt in status not saved because userKey was not specified');

    return Promise.reject((0, _errors.missingParam)('userKey'));
  }

  if (_lodash["default"].isNil(isOptedIn)) {
    _log["default"].error('Opt in status not saved because isOptedIn was not specified');

    return Promise.reject((0, _errors.missingParam)('isOptedIn'));
  }

  return storage.post("state/".concat(userKey, "/beta-opt-in"), {
    isOptedIn: isOptedIn
  }, {
    headers: {
      'Content-Type': 'text/plain'
    }
  });
};

var fetchOptInStatusForUser = function fetchOptInStatusForUser(userKey) {
  return storage.get("state/".concat(userKey, "/beta-opt-in"));
};

var deleteOptInStatusForUser = function deleteOptInStatusForUser(userKey) {
  return storage["delete"]("state/".concat(userKey, "/beta-opt-in"));
};

var fetchViewedTutorials = function fetchViewedTutorials(userKey) {
  return storage.get("state/".concat(userKey, "/viewedTutorials"));
};

var saveViewedTutorials = function saveViewedTutorials(userKey, viewedTutorials) {
  if (_lodash["default"].isEmpty(viewedTutorials)) {
    return Promise.reject((0, _errors.missingParam)('viewedTutorials'));
  }

  return storage.post("state/".concat(userKey, "/viewedTutorials"), viewedTutorials, {
    headers: {
      'Content-Type': 'text/plain'
    }
  });
};

var saveSelectedCustomLesson = function saveSelectedCustomLesson(userKey, lessonKey, lessonData) {
  if (_lodash["default"].isEmpty(userKey)) {
    _log["default"].error('Selected lesson not saved because userKey was not specified');

    return Promise.reject((0, _errors.missingParam)('userKey'));
  }

  if (_lodash["default"].isEmpty(lessonKey)) {
    _log["default"].error('Selected lesson not saved because lessonKey was not specified');

    return Promise.reject((0, _errors.missingParam)('lessonKey'));
  }

  if (_lodash["default"].isEmpty(lessonData)) {
    _log["default"].error('Selected lesson not saved because lessonData was not specified');

    return Promise.reject((0, _errors.missingParam)('lessonData'));
  }

  return storage.post("state/".concat(userKey, "/selected-custom-lesson:").concat(lessonKey), lessonData, {
    headers: {
      'Content-Type': 'text/plain'
    }
  });
};

var fetchSelectedCustomLesson = function fetchSelectedCustomLesson(userKey, lessonKey) {
  return storage.get("state/".concat(userKey, "/selected-custom-lesson:").concat(lessonKey));
};

var fetchClientStateBatch = function fetchClientStateBatch(userKeys, path) {
  if (!userKeys) {
    return Promise.reject((0, _errors.missingParam)('userKeys'));
  }

  if (!path) {
    return Promise.reject((0, _errors.missingParam)('path'));
  }

  return storage.post("state/batch-get/".concat(path), userKeys, {
    headers: {
      'Content-Type': 'text/plain'
    }
  });
};

var _default = {
  saveStateToStorage: saveStateToStorage,
  fetchStateFromStorage: fetchStateFromStorage,
  deleteStateFromStorage: deleteStateFromStorage,
  fetchClientState: fetchClientState,
  saveClientState: saveClientState,
  deleteClientState: deleteClientState,
  saveLastStartedClass: saveLastStartedClass,
  saveLastLessonViewedLocation: saveLastLessonViewedLocation,
  fetchLanguageState: fetchLanguageState,
  saveLanguageState: saveLanguageState,
  fetchAllLanguageStates: fetchAllLanguageStates,
  saveAllLanguageStates: saveAllLanguageStates,
  fetchLastLessonLocation: fetchLastLessonLocation,
  fetchLastLessonViewedLocation: fetchLastLessonViewedLocation,
  fetchClassworkState: fetchClassworkState,
  saveClassworkState: saveClassworkState,
  fetchClassContentState: fetchClassContentState,
  saveClassContentState: saveClassContentState,
  saveAllClassContentStates: saveAllClassContentStates,
  fetchCustomComments: fetchCustomComments,
  saveCustomComments: saveCustomComments,
  fetchStudentState: fetchStudentState,
  saveStudentState: saveStudentState,
  saveGoogleDocId: saveGoogleDocId,
  fetchGoogleDocId: fetchGoogleDocId,
  deleteGoogleDocId: deleteGoogleDocId,
  fetchUserFile: fetchUserFile,
  saveUserFile: saveUserFile,
  saveStudentAudioAccessState: saveStudentAudioAccessState,
  saveAllStudentAudioAccessStates: saveAllStudentAudioAccessStates,
  fetchStudentAudioAccessState: fetchStudentAudioAccessState,
  fetchAllStudentAudioAccessStates: fetchAllStudentAudioAccessStates,
  saveOptInStatusForUser: saveOptInStatusForUser,
  fetchOptInStatusForUser: fetchOptInStatusForUser,
  deleteOptInStatusForUser: deleteOptInStatusForUser,
  fetchViewedTutorials: fetchViewedTutorials,
  saveViewedTutorials: saveViewedTutorials,
  saveSelectedCustomLesson: saveSelectedCustomLesson,
  fetchSelectedCustomLesson: fetchSelectedCustomLesson,
  fetchClassroomSettingState: fetchClassroomSettingState,
  saveClassroomSettingState: saveClassroomSettingState,
  fetchAllClassroomSettingStates: fetchAllClassroomSettingStates,
  saveAllClassroomSettingStates: saveAllClassroomSettingStates,
  fetchClientStateBatch: fetchClientStateBatch,
  controllerEnum: controllerEnum
};
exports["default"] = _default;